import React from 'react'
import { useSelector } from 'react-redux'
import { Modal } from 'antd-mobile'
import { useIntl } from 'react-intl'
import { getSubmitOssFormat, removeExpires } from '../../components/common/utils'
import ApplicantDetailStatus from '../../components/common/ApplicantDetailStatus'
import { isMember } from '../../reducers/selectors'
import { usePayDm, useSubmitDm } from '../../services/hooks'
import { useHistory } from 'react-router-dom'

const ApplicationStatus = ({ formData, dmFormInfo, isAutoRenewJump }) => {
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const { runAsync: toPay } = usePayDm()
  const { runAsync: submitDmRequest, loading: submitting } = useSubmitDm()

  const { signatureUrl, ismember } = useSelector((state) => ({
    signatureUrl: state.ui.signatureUrl,
    ismember: isMember(state),
  }))

  const verifySubmit = () => {
    const {
      checkedTimes,
      checkedAgreement,
      aow,
      efr,
      rescue,
      instructorNumber,
      languageId,
      regionId,
      aowFiles,
      efrfiles,
      rescueFiles,
      efri,
    } = formData
    const regionStatus = ismember ? true : regionId
    return (
      signatureUrl &&
      checkedTimes &&
      checkedAgreement &&
      (aow || aowFiles.length > 0) &&
      (efr || efrfiles.length > 0 || efri) &&
      (rescue || rescueFiles.length > 0) &&
      instructorNumber &&
      languageId &&
      regionStatus
    )
  }

  const submitDm = () => {
    if (verifySubmit()) {
      // 提交前检查候选人是否有 DM eLearning code：缺 code 弹窗提醒并阻断提交。
      // 标记随 getDetail 一起下发（dmFormInfo.hasDMElearningCode），不再单独发检查请求；
      // 只认显式 false（旧后端没有该字段 = undefined，按「不提示」处理），提交仍由服务端闸门兜底。
      if (dmFormInfo?.hasDMElearningCode === false) {
        Modal.alert(
          formatMessage({ id: 'common-errorTitle' }),
          formatMessage({ id: 'dm-form-elearning-code-missing' }),
          [{ text: formatMessage({ id: 'common-know' }) }]
        )
        return
      }
      const { regionId, ...data } = formData
      const submitData = {
        ...data,
        aowFiles: formData.aowFiles.length > 0 ? removeExpires(formData.aowFiles) : [],
        efrfiles: formData.efrfiles.length > 0 ? removeExpires(formData.efrfiles) : [],
        rescueFiles: formData.rescueFiles.length > 0 ? removeExpires(formData.rescueFiles) : [],
        handwrittenSignatureUrl: getSubmitOssFormat(signatureUrl),
      }
      if (!ismember) submitData.regionId = regionId
      submitDmRequest(submitData).then((res) => {
        if (res.code) {
          let params = {
            code: res.code,
            paid: res.paid,
            paymentType: 'MEMBER_APPLICATION_DM',
          }
          if (isAutoRenewJump) {
            params.autoRenew = isAutoRenewJump
          }
          push('/application_submit_success?type=DM', params)
        }
      })
    } else {
      Modal.alert(formatMessage({ id: 'dm-form-submit-error' }), formatMessage({ id: 'dm-form-submit-error-info' }), [
        { text: formatMessage({ id: 'common-close' }) },
      ])
    }
  }

  return (
    <ApplicantDetailStatus
      detail={dmFormInfo}
      idType={'ins'}
      submitFn={submitDm}
      payFn={toPay}
      applicationType={'DM'}
      payApplicationType={'MEMBER_APPLICATION_DM'}
      loading={submitting}
    />
  )
}

export default ApplicationStatus
